import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

export const FeedbackChangeBankAccount: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const size = useWindowSize();
    const storage = localStorage.getItem('storage') || '';
    const { trackingScreenView } = new TrackingEvents();
    let state: any;
    let err: any;
    if (storage) {
        const storageJson = JSON.parse(storage);
        state = storageJson.state;
        err = storageJson.err;
    }
    const stateFeedback = state;
    const error = err;

    const sendToNative = (url: string) => {
        navigate(url, { state });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <>
            <div
                className='feedbackChangeBankAccount-page'
                style={{
                    background:
                        stateFeedback === 'SUCCESS'
                            ? size.width < 1024 || size.height < 550
                                ? skinVars.colors.backgroundBrand
                                : ''
                            : skinVars.colors.background,
                }}
            >
                {stateFeedback === 'SUCCESS' ? (
                    <SuccessFeedbackScreen
                        title={t('titleFeedbackSuccessBankAccount')}
                        description={t('descriptionFeedbackSuccsessBankAccount')}
                        primaryButton={
                            <ButtonPrimary
                                onPress={() => {
                                    sendToNative('/profile');
                                }}
                            >
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                    ></SuccessFeedbackScreen>
                ) : (
                    <ErrorFeedbackScreen
                        title={error?.title}
                        description={error?.localizedDescription}
                        errorReference={'Código de error: ' + `${error?.id}`}
                        primaryButton={
                            <ButtonPrimary
                                onPress={() => {
                                    sendToNative('/profile');
                                }}
                            >
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                    ></ErrorFeedbackScreen>
                )}
            </div>
        </>
    );
};

export default FeedbackChangeBankAccount;
